<template>
  <router-link class="card" :to="/clubs/ + club.clubId">
    <div class="card-header">{{ club.name }}</div>
    <div class="card-details">
      <section>{{ $t('clubs.code') }} : {{club.code}}</section>
    </div>
  </router-link>
</template>

<script>

export default {
  name: 'ClubCard',
  components: {},
  props: {
    club: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

/* mobile */
@media screen and (max-width: 600px) {

  header {
    font-size: 5vw;
    padding: 2vw;
  }

  .details {
    padding: 2vw;
  }

}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {

  header {
    font-size: 1.5vw;
    padding: 1vw;
    cursor: pointer;
  }

  .details {
    padding: 1vw;
  }

}

/* laptop */
@media screen and (min-width: 1281px) {

  header {
    font-size: 1.5vw;
    padding: 1vw;
    cursor: pointer;
  }

  .details {
    padding: 1vw;
  }

}

</style>
